<!-- Header section -->
<login-header></login-header>

<div class="fc_lp_hero" style="background-image: url('/assets/images/fc-hero-bg.png');">
    <div class="px-90 m-auto">
        <div class="hero_top d-grid justify-content-between align-items-center gap-5">
            <div class="hero_text">
                <h1 class="lp_h1 mb-5">Joyful moments, <br> deeper bonds, thriving <br> families</h1>
                <a routerLink="/questionnaires" class="primary_btn">Get started - Free trial</a>
            </div>
            <div class="hero_img">
                <img class="w-100" src="/assets/images/newHomeABtest/fc-lp-hero.png" alt="">
            </div>
        </div>
        <div class="feature_boxes">
            <div class="feature_single">
                <img src="/assets/images/connect-icon.svg" width="58" height="58" alt="">
                <h2 class="lp_h2 my-3">Connect</h2>
                <p class="mb-0">Start your journey to a more connected family.</p>
            </div>
            <div class="feature_single">
                <img src="/assets/images/organize-icon.svg" width="52" height="58" alt="">
                <h2 class="lp_h2 my-3">Organize</h2>
                <p class="mb-0">Keep your family info organized. Goodbye clutter!</p>
            </div>
            <div class="feature_single">
                <img src="/assets/images/create-icon.svg" width="70" height="58" alt="">
                <h2 class="lp_h2 my-3">Create</h2>
                <p class="mb-0">Capture heartfelt messages and share it with your loved ones.</p>
            </div>
            <div class="feature_single">
                <img src="/assets/images/protect-icon.svg" width="58" height="58" alt="">
                <h2 class="lp_h2 my-3">Protect</h2>
                <p class="mb-0">Keep your loved ones safe and feeling secure.</p>
            </div>
        </div>
    </div>
</div>

<!-- All-in-one -->
<div class="allinone_section">
    <div class="px-90 m-auto">
        <h2 class="lp_h2 mb-5 text-center">All-in-One Solution to meet all your family’s needs</h2>

        <div class="single_solution">
            <div class="single_solution_text d-flex justify-content-center">
                <div class="solution_text">
                    <h3 class="lp_h3">Files</h3>
                    <p>Information that you and your family needs everyday at your fingertips.</p>
                </div>
            </div>
            <div class="single_solution_img">
                <img class="w-100" src="/assets/images/newHomeABtest/Files.png" alt="" loading="lazy">
            </div>
        </div>

        <div class="single_solution">
            <div class="single_solution_img">
                <img class="w-100" src="/assets/images/newHomeABtest/PersonalVault.png" alt="" loading="lazy">
            </div>
            <div class="single_solution_text d-flex justify-content-center">
                <div class="solution_text">
                    <h3 class="lp_h3">Personal Vault</h3>
                    <p>Individual vaults for each family member, with secure access.</p>
                </div>
            </div>
        </div>

        <div class="single_solution">
            <div class="single_solution_text d-flex justify-content-center">
                <div class="solution_text">
                    <h3 class="lp_h3">Legacy Messages</h3>
                    <p>Create lasting memories with heartfelt stories in video and audio.</p>
                </div>
            </div>
            <div class="single_solution_img">
                <img class="w-100" src="/assets/images/newHomeABtest/LegacyMessages.png" alt="" loading="lazy">
            </div>
        </div>

        <div class="single_solution">
            <div class="single_solution_img">
                <img class="w-100" src="/assets/images/newHomeABtest/LiveGPSEmergencyCalling.png" alt="" loading="lazy">
            </div>
            <div class="single_solution_text d-flex justify-content-center">
                <div class="solution_text">
                    <h3 class="lp_h3">Live GPS & Emergency Calling</h3>
                    <p>See your family members’ location with just one touch. Help is just a tap away with  emergency calling.</p>
                </div>
            </div>
        </div>

    </div>
</div>



<div class="everyday_life">
    <div class="px-90 m-auto">
        <h2 class="lp_h2 mb-5 text-center text-white">Everyday life is overwhelming! And so, we have made it easy for you.</h2>

        <div class="everyday_life_details">
            <div class="everyday_box">
                <div class="everyday_title">
                    <img src="/assets/images/family-calendar-icon.svg" width="46" height="47" alt="" loading="lazy">
                    <h3 class="lp_h3 mb-0">Family Calendar</h3>
                </div>
                <p class="mb-0">Manage your family's schedule seamlessly and celebrate life's milestones.</p>
            </div>
            <div class="everyday_box">
                <div class="everyday_title">
                    <img src="/assets/images/photos-videos-icon.svg" alt="" width="46" height="47" alt="" loading="lazy">
                    <h3 class="lp_h3 mb-0">Photos & Videos</h3>
                </div>
                <p class="mb-0">Organize, create  and share photos and videos.</p>
            </div>
            <div class="everyday_box">
                <div class="everyday_title">
                    <img src="/assets/images/emergency-prep-icon.svg" alt="" width="46" height="47" alt="" loading="lazy">
                    <h3 class="lp_h3 mb-0">Emergency Prep</h3>
                </div>
                <p class="mb-0">Be prepared and respond confidently to any emergency.</p>
            </div>
        </div>
    </div>
</div>

<div class="family_usages_section">
    <div class="px-90 m-auto">
        <h2 class="lp_h2 mb-5 text-center">Who can use Family Central?</h2>

        <div class="family_usages">
            <div class="single_usages">
                <img width="w-100" src="/assets/images/newHomeABtest/for-families-image.png" alt="" loading="lazy">
                <div class="single_usages_details">
                    <h3 class="lp_h3 mb-2">For Families</h3>
                    <p class="mb-4">Connect your family and your most valuable information.</p>
                    <a href="/families" [ngClass]="{'active': isFamiliespage}" class="primary_btn">Learn more</a>
                </div>
            </div>
            <div class="single_usages">
                <img width="w-100" src="/assets/images/newHomeABtest/for-professionals-image.webp" alt="" loading="lazy">
                <div class="single_usages_details">
                    <h3 class="lp_h3 mb-2">For Professionals</h3>
                    <p class="mb-4">Help your clients protect and build their legacy.</p>
                    <a routerLink="/professional" [routerLinkActive]="['active']" class="primary_btn">Learn more</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ask_anything_section">
    <div class="px-90 m-auto text-center">
        <h2 class="lp_h2 mb-2">Ask us anything!</h2>
        <p class="mb-0">We’re here for all your questions</p>

        <div class="contact_options my-4">
            <ul class="contact_btns d-flex flex-wrap justify-content-center">
                <li>
                    <a class="btn border rounded-3 p-3" href="mailto:hello&#64;familycentral.com">
                        <img class="mb-3" src="/assets/images/newHomeABtest/email-icon.svg" width="40" height="40" alt="" loading="lazy">
                        <strong class="d-block">Email</strong>
                        <p>Our friendly team is here to help.</p>
                        <span>hello&#64;familycentral.com</span>
                    </a>
                </li>
                <li>
                    <a class="btn border rounded-3 p-3" href="tel:+1888-780-3264">
                        <img class="mb-3" src="/assets/images/newHomeABtest/phone-icon.svg" width="40" height="40" alt="" loading="lazy">
                        <strong class="d-block">Phone</strong>
                        <p>Mon-Fri from 8am to 7pm EST</p>
                        <span>1-888-780-3264</span>
                    </a>
                </li>
                <li>
                    <a class="btn border rounded-3 p-3" routerLink="/book-an-appointment">
                        <img class="mb-3" src="/assets/images/newHomeABtest/phone-icon.svg" width="40" height="40" alt="" loading="lazy">
                        <strong class="d-block">Appointment</strong>
                        <p>Mon-Fri from 8am to 7pm EST</p>
                        <span>Book an appointment</span>
                    </a>
                </li>
            </ul>
        </div>

        <p class="visit_faq">Visit our <a routerLink="/faq" class="text_red">FAQs</a> page</p>
    </div>
</div>

<!-- Download app -->
<div class="download_app">
    <div class="px-90 m-auto">
        <div class="download_app_content">
            <div class="download_app_image">
                <img src="/assets/images/newHomeABtest/download-app-image.png" alt="" loading="lazy">
            </div>
            <div class="download_app_heading">
                <h2 class="lp_h2">Connect deeper, <br>spark joy, <br>build your family legacy!</h2>
            </div>
            <div class="download_app_links">
                <h3 class="lp_h3">Download the App!</h3>
                <ul>
                    <li><a href="https://apps.apple.com/in/app/familycentral-family-office/id6476486249"><img src="/assets/images/appstore-black.svg" width="215" height="65" alt="Download from apps store" loading="lazy"></a></li>
                    <li><a href="https://play.google.com/store/apps/details?id=com.familycentral.client"><img src="/assets/images/playstore-black.svg" width="215" height="65" alt="Download from play store" loading="lazy"></a></li>
                </ul>
            </div>
        </div>
    </div>
</div>


<!--  Unlock family magic -->
<div class="unlock_family_magic">
    <div class="px-90 m-auto text-center">
        <h2 class="lp_h2 mb-5">Unlock family magic, free 14-day trial.</h2>

        <ul class="family_magic_list">
            <li class="d-flex gap-3"><img src="/assets/images/check-circle-blue.png" width="37" height="37" alt="" loading="lazy"> <span>8 total members</span></li>
            <li class="d-flex gap-3"><img src="/assets/images/check-circle-blue.png" width="37" height="37" alt="" loading="lazy"> <span>Video concierge support (8am-5pm)</span></li>
            <li class="d-flex gap-3"><img src="/assets/images/check-circle-blue.png" width="37" height="37" alt="" loading="lazy"> <span>250 GB storage</span></li>
            <li class="d-flex gap-3"><img src="/assets/images/check-circle-blue.png" width="37" height="37" alt="" loading="lazy"> <span>Chat/email & phone support</span></li>
        </ul>

        <div class="pricing_box text-center">
            <h3 class="lp_h3">Try for Free for 14-days, then $199/year</h3>
            <p class="mb-0">$16.60/month, billed annually</p>
        </div>

        <a routerLink="/questionnaires" class="primary_btn">Unlock family magic</a>
    </div>
</div>

<!-- Footer section -->
<app-footer></app-footer>
